// extracted by mini-css-extract-plugin
export default {"row":"Cognition_row__P0oZ+","col1":"Cognition_col1__o8PvG","col2":"Cognition_col2__ch3GI","col3":"Cognition_col3__c-yCf","col4":"Cognition_col4__dzX9Y"};